@if (loading) {
  <div class="page-loader spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else if (!metadataReady) {
  <p role="alert">{{ metadataError || 'Status e modelos ainda não carregados.' }}</p>
  <button mat-button (click)="carregarOpcoes()">Tentar novamente</button>
} @else {
  <div class="container">
    <p class="resumo">
      <mat-icon>fact_check</mat-icon>
      {{ quantidade }} pedido(s) selecionado(s). Limite de 100 pedidos por ação.
    </p>

    <mat-form-field>
      <mat-label>Status do Resgate</mat-label>
      <mat-select [(value)]="selectedStatus">
        @for (rescueStatus of rescueStatuses; track $index) {
          <mat-option [value]="rescueStatus.id_status">{{
            rescueStatus.descricao.toUpperCase()
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (templateDoStatus) {
      <!-- O e-mail decorre do status: exibido, nunca escolhido. -->
      <mat-form-field>
        <mat-label>E-mail que será disparado</mat-label>
        <input matInput [value]="nomeTemplate" readonly disabled />
        <mat-icon matSuffix>mail</mat-icon>
      </mat-form-field>
    } @else {
      <p class="sem-envio">
        <mat-icon>info</mat-icon>
        Nenhum e-mail será enviado nesta alteração.
      </p>
    }

    <button (click)="confirmar()" [disabled]="!podeSalvar()" class="edit-btn" matButton="filled">
      Alterar status
    </button>
  </div>
}
